import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import useBreakpoint from 'hooks/useBreakpoint/useBreakpoint';

import * as mainStyles from '../styles';
import useStyles from './styles';
import { FooterParams } from './types';

const Footer = ({ buttonLabel, buttonCallback, buttonDisabled }: FooterParams) => {
  const classes = useStyles();
  const mainClasses = mainStyles.useStyles();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === 'xs';

  return (
    <Grid container className={classes.footerContainer}>
      {buttonLabel && buttonCallback && isMobile && (
        <Grid item xs={12} sm={6}>
          <div className={classes.buttonContainerMobile}>
            <Button
              classes={{ root: mainClasses.button, disabled: mainClasses.buttonDisabled }}
              variant="contained"
              color="primary"
              disabled={!!buttonDisabled}
              onClick={buttonCallback}
            >
              {buttonLabel}
            </Button>
          </div>
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <div className={classes.iconContainer}>
          <img
            width="40px"
            src="https://assets.doctor.com/cms/ICON-HIPAA.png"
            srcSet="https://assets.doctor.com/cms/ICON-HIPAA.png,
                https://assets.doctor.com/cms/ICON-HIPAA.png 2x,
                https://assets.doctor.com/cms/ICON-HIPAA.png 3x"
            alt="hipaa icon"
          />
          <div className={classes.iconText}>
            HIPAA <br />
            Compliant{' '}
          </div>
          <img
            width="40px"
            src="https://assets.doctor.com/cms/ICON-Secure.png"
            srcSet="https://assets.doctor.com/cms/ICON-Secure.png,
                https://assets.doctor.com/cms/ICON-Secure.png 2x,
                https://assets.doctor.com/cms/ICON-Secure.png 3x"
            alt="hipaa icon"
          />
          <div className={classes.iconText}>
            SSL <br />
            Secured
          </div>
        </div>
      </Grid>
      {buttonLabel && buttonCallback && !isMobile && (
        <Grid item xs={12} sm={6}>
          <div className={classes.buttonContainer}>
            <Button
              classes={{ root: mainClasses.button, disabled: mainClasses.buttonDisabled }}
              variant="contained"
              color="primary"
              disabled={!!buttonDisabled}
              onClick={buttonCallback}
            >
              {buttonLabel}
            </Button>
          </div>
        </Grid>
      )}
    </Grid>
  );
};

export default Footer;
